require('./index.css');


// var arr = ["PICTURE_ONE","PICTURE_TWO","PICTURE_THREE","PICTURE_FOUR"]

// $(document).on('click', 'a[data-sid]', function (e) {

//   var vid = $(this).attr('data-sid');
//   _qblog.wsd.click('TRANSLATESYNCSPREAD.' + arr[vid-1]);
// });



// WEBPACK FOOTER //
// ./modules/solution/index.js